<template>
  <el-dialog
    :title="'添加权限人员-' + identify.name"
    :visible.sync="dialogVisible"
    custom-class="zyyj-dialog"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    @open="handleOpen"
  >
    <div class="menu-container">
      <div class="content scroll">
        <el-checkbox-group v-model="checkList">
          <ul>
            <li
              v-for="(person, key, index) in persons"
              :key="index + '-person'"
            >
              <div
                style="min-height: 28px; line-height: 1; width: 100%"
                :id="'anchor-' + key"
              >
                <label class="key">{{ key.toUpperCase() }}</label>
                <div
                  style="
                    display: inline-block;
                    margin-left: 10px;
                    width: calc(100% - 30px);
                  "
                >
                  <template v-for="teacher in person">
                    <el-checkbox
                      v-if="teacher"
                      :key="teacher.value"
                      :label="teacher.value"
                    >
                      <el-tooltip placement="top">
                        <div slot="content">{{ teacher.name }}</div>
                        <span>{{ teacher.name }}</span>
                        ></el-tooltip
                      >
                    </el-checkbox>
                  </template>
                </div>
              </div>
            </li>
          </ul>
        </el-checkbox-group>
      </div>
      <ul class="menu">
        <li
          v-for="item in menuIndex"
          :key="item"
          :class="active === item ? 'active' : 'menu-item'"
          @click="clickMenu(item)"
        >
          {{ item }}
        </li>
      </ul>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :disabled="submitting"
        @click="submitSubject"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
// import _ from 'lodash'
export default {
  props: ['identify', 'visible', 'type'],

  components: {},

  data () {
    return {
      active: 'A',
      checkList: [],
      persons: [],
      submitting: false,
      menuIndex: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    }
  },

  watch: {

  },

  computed: {
    dialogVisible: {
      get () { return this.visible === true },
      set () { this.$emit('update:visible', false) }
    }
  },

  mounted () {

  },

  methods: {
    handleOpen () {
      this.persons = this.identify.availablePerson
      this.checkList = this.identify.person
    },

    clickMenu (item) {
      this.active = item
      let ele = '#anchor-' + item.toLowerCase()
      const anchorEle = document.querySelector(ele)
      if (anchorEle) {
        anchorEle.scrollIntoView(true)
      }
    },

    closeDialog () {
      if (this.isLastSuccessful) {
        this.$emit('edit-result', true)
      }
      this.$emit('update:visible', false)
    },

    submitSubject () {
      let param = {
        userIds: this.checkList
      }
      this.$xhrPost(`/acc/preset-roles/${this.identify.id}/members`, param).then(rs => {
        if (rs.code === 'SUCCESS') {
          this.isLastSuccessful = true
          this.$message.success('操作成功')
          this.closeDialog()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  border: none;
}
/deep/ .el-dialog__footer {
  text-align: right;
}
/deep/ .el-checkbox__input {
  margin-bottom: 10px;
}
/deep/ .el-checkbox__label {
  width: 60px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.menu-container {
  position: relative;
  height: 520px;
}
.menu {
  position: absolute;
  display: inline-block;
  right: 0;
}
.content {
  display: inline-block;
  width: calc(100% - 25px);
  height: 100%;
  overflow-y: scroll;
  scroll-behavior: smooth;
}
.menu li {
  padding: 3px;
}
.menu .active {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;
  background-color: var(--theme-color);
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  width: 22px;
  height: 14px;
}
.menu-item {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 22px;
  height: 14px;
}
.key {
  display: inline-block;
  font-size: 16px;
  width: 16px;
  text-align: center;
  color: #cacaca;
  vertical-align: top;
}
/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/components/common/AddPermissionPerson.vue